// extracted by mini-css-extract-plugin
module.exports = {"BundlesDetailsAccordianUI":"BundleDetailsAccordianUI_BundlesDetailsAccordianUI__rbVOf","accordianContainer":"BundleDetailsAccordianUI_accordianContainer__NrOnG"};